import React from "react";

function Pagination({
  currentPage = 1,
  lastPage = 1,
  total = 0,
  from = 0,
  to = 0,
  onPageChange,
  itemName = "items",
}) {
  if (total <= 0) return null;

  const handlePageClick = (page) => {
    if (page >= 1 && page <= lastPage && page !== currentPage) {
      if (onPageChange) onPageChange(page);
    }
  };

  const getPageNumbers = () => {
    if (lastPage <= 7) {
      return Array.from({ length: lastPage }, (_, i) => i + 1);
    }
    const pages = [];
    if (currentPage <= 4) {
      for (let i = 1; i <= 5; i++) pages.push(i);
      pages.push("...");
      pages.push(lastPage);
    } else if (currentPage >= lastPage - 3) {
      pages.push(1);
      pages.push("...");
      for (let i = lastPage - 4; i <= lastPage; i++) pages.push(i);
    } else {
      pages.push(1);
      pages.push("...");
      pages.push(currentPage - 1);
      pages.push(currentPage);
      pages.push(currentPage + 1);
      pages.push("...");
      pages.push(lastPage);
    }
    return pages;
  };

  return (
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 pt-3 border-top">
      <div className="text-grey-600 font-xssss fw-500 mb-2 mb-md-0">
        Showing <span className="fw-700 text-grey-900">{from || 0}</span> to{" "}
        <span className="fw-700 text-grey-900">{to || 0}</span> of{" "}
        <span className="fw-700 text-grey-900">{total}</span> {itemName}
      </div>

      {lastPage > 1 && (
        <nav aria-label="Pagination Navigation">
          <ul className="pagination mb-0 gap-1 align-items-center">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                type="button"
                className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-2 text-grey-800"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &laquo; Prev
              </button>
            </li>

            {/* Page Number Buttons */}
            {getPageNumbers().map((p, idx) =>
              p === "..." ? (
                <li key={`ellipsis-${idx}`} className="page-item disabled px-1">
                  <span className="text-grey-500 font-xssss">...</span>
                </li>
              ) : (
                <li key={`page-${p}`} className="page-item">
                  <button
                    type="button"
                    className={`btn btn-sm font-xssss fw-600 px-2 py-1 rounded-2 ${
                      currentPage === p
                        ? "btn-danger text-white"
                        : "btn-light text-grey-800"
                    }`}
                    style={{ minWidth: "32px" }}
                    onClick={() => handlePageClick(p)}
                  >
                    {p}
                  </button>
                </li>
              )
            )}

            {/* Next Button */}
            <li className={`page-item ${currentPage === lastPage ? "disabled" : ""}`}>
              <button
                type="button"
                className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-2 text-grey-800"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === lastPage}
              >
                Next &raquo;
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}

export default Pagination;

